import { getToken, onMessage } from "firebase/messaging";
import { VAPID_KEY } from "helpers/firebase/fcm";
import { toast } from "react-toastify";

export class FirebaseCloudMessagingService {
  constructor(messaging, navigate) {
    console.log("🚀 FCM Service constructor called");
    this.messaging = messaging;
    this.navigate = navigate;
    this.initialize();
  }

  async initialize() {
    console.log("🔧 FCM Service initializing...");

    try {
      const permission = await Notification.requestPermission();
      console.log("📢 Notification permission:", permission);

      if (permission === "granted") {
        const token = await getToken(this.messaging, {
          vapidKey: VAPID_KEY, // Make sure this is set!
        });

        if (token) {
          console.log("✅ FCM Token generated:", token);
        } else {
          console.warn("⚠️ No FCM token available");
        }

        this.addListenerOnForegroundMessage();
        console.log("✅ Foreground listener added");
      } else {
        console.warn("⚠️ Notification permission denied");
      }
    } catch (error) {
      console.error("❌ Error initializing FCM:", error);
    }
  }

  addListenerOnForegroundMessage() {
    console.log("👂 Setting up foreground message listener...");

    onMessage(this.messaging, (payload) => {
      console.log("🎉 ====== FOREGROUND MESSAGE RECEIVED ======");
      console.log("Full payload:", JSON.stringify(payload, null, 2));

      this.showToast(payload);
      this.showNativeNotification(payload);
    });

    console.log("✅ Listener setup complete");
  }

  showNativeNotification(payload) {
    console.log("🔔 Showing native notification...");

    if (Notification.permission === "granted") {
      const title = payload?.notification?.title || "New Notification";
      const options = {
        body: payload?.notification?.body || "",
        icon: "/logo.png",
        badge: "/logo.png",
        data: payload?.data,
        tag: payload?.data?.relevant_id || "notification",
      };

      console.log("Notification options:", options);

      const notification = new Notification(title, options);

      notification.onclick = () => {
        console.log("Native notification clicked!");
        notification.close();
        this.handleNotificationClick(payload);
      };
    } else {
      console.warn(
        "⚠️ Cannot show notification, permission:",
        Notification.permission
      );
    }
  }

  handleNotificationClick(payload) {
    console.log("🖱️ Handling notification click...");
    const relevantType = payload?.data?.relevant_type;
    const relevantId = payload?.data?.relevant_id;

    window.focus();

    if (relevantType === "quote" && relevantId) {
      console.log("➡️ Navigating to quote details:", relevantId);
      this.navigate("/quote-details", { state: { id: relevantId } });
    } else if (relevantType === "invoice" && relevantId) {
      console.log("➡️ Navigating to invoice details:", relevantId);
      this.navigate("/invoice-details", { state: { id: relevantId } });
    }
  }

  showToast(payload) {
    console.log("🍞 Showing toast notification...");

    const title = payload?.notification?.title || "Notification";
    const body = payload?.notification?.body || "";

    toast.info(
      <div>
        <strong>{title}</strong>
        <div>{body}</div>
      </div>,
      {
        onClick: () => {
          console.log("Toast clicked", payload.data);
          this.handleNotificationClick(payload);
        },
      }
    );
  }
}
